(function() {
  function loadJQuery(callback) {
    if (window.jQuery === undefined) {
      let script = document.createElement('script');
      script.src = "https://code.jquery.com/jquery-3.6.0.min.js";
      script.onload = function() {
        jQuery.noConflict();
        callback(jQuery);
      };
      document.head.appendChild(script);
    } else {
      callback(jQuery);
    }
  }

  loadJQuery(function($) {
    
    (function($){
      $.fn.glassesConfigurator = function(options){
        const config = $.extend({
          summarySelector: '[data-src]',
          priceOutputSelector: '[data-src="price-total"]',
          cartButtonSelector: '#add-to-cart-form, #add-to-cart-footer',
          cartButtonSelectorFrame: '#add-to-cart-form-frame',
          outputJsonCallback: function(json) {
            console.log("Konfiguration:", json);
          }
        }, options);
    
        const $form = this;
    
        function updateSummaryAndPrice() {

          let configData = {
            eye: {},
            glas: {},
            extras: [],
            totalPrice: 0,
            articleIds: []
          };

          //54756403872089

          var cCheck = jQuery("[data-article-id='54756403872089']").is(":checked");
          var cCheck2 = jQuery("[data-article-id='56325992874329']").is(":checked");
          if(cCheck || cCheck2){
            jQuery("._hide_on_campaign").css("display", "none");
            jQuery("._show_on_campaign").css("display", "flex");
          }else{
            jQuery("._hide_on_campaign").css("display", "flex");
            jQuery("._show_on_campaign").css("display", "none");
          }
    
          let price = 0;
    
          // Brillenwerte (konf[eye][r][sph], etc.)
          $form.find('select[name^="konf"]').each(function() {
            const name = $(this).attr('name').replace(/[\[\]]+/g, '-').replace(/^-|-$/g, '');
            const val = $(this).val();
            configData.eye[name] = val;
    
            // Ausgabe in Zusammenfassung
            const $out = $(`[data-src="${name}"]`);
            if ($out.length) $out.text(val);
          });
    
          // Glasauswahl
          const $glas = $form.find('input[name="glasses"]:checked');
          if ($glas.length) {
            const val = $glas.val();
            const priceVal = parseFloat($glas.data('price')) || 0;
            const articleId = $glas.data('article-id');
            const label = $glas.data('label');
            const name = $glas.attr('name');
    
            configData.glas = {
              id: val,
              articleId: articleId,
              label: label,
              name: name,
              price: priceVal
            };

            const $out = $(`[data-src="${name}"]`);
            if ($out.length) $out.text(label);
            
            price += priceVal;
            configData.articleIds.push(articleId);
          }
    
          // Extras (alle .is--extras inputs)
          $form.find('input.is--extras:checked').each(function() {
            const id = $(this).attr('id');
            const articleId = $(this).data('article-id');
            const priceVal = parseFloat($(this).data('price')) || 0;
            const label = $form.find(`label[for="${id}"]`).text().trim();
            const name = $(this).attr('name');
    
            configData.extras.push({
              id: id,
              articleId: articleId,
              label: label,
              price: priceVal,
              name: name
            });
    
            // Ausgabe
            const $out = $(`[data-src="${name}"]`);
            if ($out.length) $out.text(label);
    
            price += priceVal;
            if (articleId) configData.articleIds.push(articleId);
          });
    
          configData.totalPrice = price;
    
          // Preis ausgeben
//          $(config.priceOutputSelector).text(price.toFixed(2).replace('.', ',') + ' €');
          $(config.priceOutputSelector).text(price + ' €');
    
          return configData;
        }
    
        // Events
        $form.on('change', 'select, input', updateSummaryAndPrice);
    
        // Bei Klick auf "In den Warenkorb"
        $(config.cartButtonSelector).on('click', function(e){
          e.preventDefault();
          const json = updateSummaryAndPrice();
          config.outputJsonCallback(json);
        });

        // Bei Klick auf "In den Warenkorb"
        $(config.cartButtonSelectorFrame).on('click', function(e){
          e.preventDefault();

          let configData = {
            dpt: {},
            glas: {},
            extras: [],
            totalPrice: 0,
            articleIds: []
          };
          
          $form.find('select[name="konf[dpt]"]').each(function() {
            const val = $(this).val();
            configData["dpt"] = val;
          });
          
          let frameProductId = jQuery("form.installment input[name=id]").val() ;
          let storagePlace = jQuery("._storagePlace").text();

          let frame = {
            id: frameProductId,
            quantity: 1,
            properties: {
              "config": configData,
              "storage_place": storagePlace, 
              "is_main": true
            }
          };

          
          let itemsToAdd = [frame];
  
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: JSON.stringify({ items: itemsToAdd }),
            contentType: "application/json",
            dataType: "json",
            success: function() {
              alert("Ihre Brille wurde dem Warenkorb hinzugefügt!");
              window.location.href = "/cart";
            },
            error: function(xhr) {
              console.error("Fehler beim Hinzufügen:", xhr.responseText);
              console.log(itemsToAdd);
              alert("Fehler beim Hinzufügen der Produkte!");
            }
          });
          
        });
    
        // Initiale Ausführung
        updateSummaryAndPrice();
    
        return this;
      };
    })(jQuery);

    
    $(document).on("modal:shown", function(){
        var modal = document.getElementsByClassName("is-konfigurator");

        jQuery("variant-selects input").each(function(i, el){
          jQuery(modal).removeClass("is--"+$(el).val().toLowerCase());
        });

       jQuery(".is--frametype").each(function(i, el){
          jQuery(modal).addClass("is--"+$(el).data("frame-type").toLowerCase());
        });      
      
        let productType = jQuery("variant-selects input:checked").val();
        jQuery(modal).addClass("is--"+productType.toLowerCase());

        if(jQuery(modal).hasClass("is--gleitsichtbrille") && jQuery(modal).hasClass("is--randlos")){
          jQuery("[data-index='15']").attr("disabled",true);
          jQuery("[data-index='15']").parent("label").css("opacity","0.5");
          jQuery(".is--gleitsicht [data-index='16']:first").click();
        }

        if(jQuery(modal).hasClass("is--randlos")){        

        }

        if(jQuery(modal).hasClass("is--gleitsichtbrille") && jQuery(modal).hasClass("is--halbrand")){
          jQuery("[data-index='15']").attr("disabled",true);
          jQuery("[data-index='15']").parent("label").css("opacity","0.5");
          jQuery(".is--gleitsicht [data-index='16']:first").click();
        }

        if(jQuery(modal).hasClass("is--officebrille") && jQuery(modal).hasClass("is--halbrand")){
          jQuery("[data-index='15']").attr("disabled",true);
          jQuery("[data-index='15']").parent("label").css("opacity","0.5");
          jQuery(".is--halbrand .is--officebrille  [data-index='16']:first").click();
        }

        if(jQuery(modal).hasClass("is--fernbrille") && jQuery(modal).hasClass("is--halbrand")){
          jQuery("[data-index='15']").attr("disabled",true);
          jQuery("[data-index='15']").parent("label").css("opacity","0.5");
          jQuery(".is--fernbrille [data-index='16']:first").click();
        }

        if(jQuery(modal).hasClass("is--lesebrille") && jQuery(modal).hasClass("is--halbrand")){
          jQuery("[data-index='15']").attr("disabled",true);
          jQuery("[data-index='15']").parent("label").css("opacity","0.5");
          jQuery(".is--lesebrille [data-index='16']:first").click();
        }

        const styleHeight = modal[0].clientHeight;     
        if(jQuery("#sticky-footer").css("display") != "none"){
          document.getElementById('scrollSpyContainer').style.height = (styleHeight-200)  +"px";
        }else{
          document.getElementById('scrollSpyContainer').style.height = (styleHeight-20)  +"px";
        }
          
        const scrollElem = document.querySelector(`[data-bs-spy="scroll"]`)
        bootstrap.ScrollSpy.getOrCreateInstance(scrollElem).refresh()

        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));

        jQuery(".is--highlight:visible input:first").click(); 


      var cookieconfig = getCookie("rlconfig");
      console.log(cookieconfig);
      if (cookieconfig !== undefined) {
          cookieconfig = JSON.parse(cookieconfig);
          
          console.log(cookieconfig.length);
          if (typeof cookieconfig === 'object' && cookieconfig !== null) {

              $.each(cookieconfig, function (i, item) {

                var tmp = i.split("-");
                var targetfield = jQuery("[name='" + tmp[0] + "["+tmp[1]+"]["+tmp[2]+"]["+tmp[3]+"]']");
                
                  if (targetfield) {
                      targetfield.val(item.value);

                      $('option', targetfield)
                          .removeAttr('selected')
                          .filter('[value="'+item+'"]')
                          .attr('selected', true);
                  }

              });
          }
      }
    });
    
    // Initialisierung:
    $(document).ready(function(){

      $("._monitorprice").on("click", function(e){
        let $item = $(e.currentTarget);
        let $target = $("."+$item.data("target"));
        
        $target.text($item.data("price"));
        
        let $modal = document.getElementsByClassName("is-konfigurator");
        let index = $(e.currentTarget).data("index");

        jQuery($modal).removeClass("is--index-15");
        jQuery($modal).removeClass("is--index-16");
        jQuery($modal).removeClass("is--index-167");

        jQuery($modal).addClass("is--index-"+index);
        
      });
      
      $('._configuratorform').glassesConfigurator({
        outputJsonCallback: function(data) {
        
          var valid = true;

          $form = $(".is-konfigurator form");
          $requiredElements = $form.find('[required]:visible');
          $requiredElements.css("outline", "0");
          $requiredElements.each(function(i, item){

            if($(item).val() == ""){
              $(item).css("outline", "4px solid red");
              valid = false;
            }
            
          });

          if(valid === false){
            $("#scrollSpyContainer").stop().animate({scrollTop:0}, 500, 'swing', function() {});
            return;
          }

          let productType = jQuery("variant-selects input:checked").val();
          let frameProductId = jQuery("form.installment input[name=id]").val() ;
          let bundleId = Date.now().toString();
          let storagePlace = jQuery("._storagePlace").text();
          
          let frame = {
            id: frameProductId,
            quantity: 1,
            properties: {
              "config": data.eye,
              "bundle_id": bundleId,
              "is_main": true,
              "glas": data.glas.label,
              "extras": data.extras[0].label,
              "storage_place": storagePlace, 
            }
          };

          let glas = {
            id: data.glas.articleId,
            quantity: 1,
            properties: {
              "bundle_id": bundleId
            }
          };

          let extras = {
            id: data.extras[0].articleId,
            quantity: 1,
            properties: {
              "bundle_id": bundleId
            }
          };
   
          let itemsToAdd = [glas, extras, frame];

          var jsonConfig = JSON.stringify(data.eye);
          var cstring  = 'rlconfig='+jsonConfig+'; path=/; max-age='+ (60 * 60 * 24 * 14) +';expires=' + new Date(2099, 10, 29, 11, 00, 00)+';secure=false;';
          document.cookie = cstring;
  
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: JSON.stringify({ items: itemsToAdd }),
            contentType: "application/json",
            dataType: "json",
            success: function() {
              alert("Ihre Brille wurde dem Warenkorb hinzugefügt!");
              window.location.href = "/cart";
            },
            error: function(xhr) {
              console.error("Fehler beim Hinzufügen:", xhr.responseText);
              console.log(itemsToAdd);
              alert("Fehler beim Hinzufügen der Produkte!");
            }
          });
          
        }
      });   
      
    });

    $(window).scroll(function () {
      //image scroll on detailpage
      if ($(".product__media-gallery-viewer-wrap").length > 0) {
          $container = $(".product__media-wrapper");

          boxheight = $container.height();
  
          var $imagebox = $(".product__media-gallery-viewer-wrap");
          var boxscroll = $(window).scrollTop();

          var scrolldelta = boxheight - $imagebox.height();

          if (boxscroll < scrolldelta) {
              $imagebox.css("top", boxscroll);
          }
      }
    });

    $(".accordion-details__summary").click(function(){
      $(window).scroll();
    });
  
  });
})();


// hide on scroll
function hideElementOnScroll(triggerSelector, targetSelector) {
    const trigger = document.querySelector(triggerSelector);
    const target = document.querySelector(targetSelector);
    
    if (!trigger || !target) return;
    
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          target.classList.add('visually-hidden');  // Fade-out
        } else {
          target.classList.remove('visually-hidden');  // Fade-in
        }
      });
    }, {
      threshold: 0.1
    });
    
    observer.observe(trigger);
}

hideElementOnScroll('#add-to-cart-form', '#sticky-footer');


/**
 * Get the value of a cookie
 * Source: https://gist.github.com/wpsmith/6cf23551dd140fb72ae7
 * @param  {String} name  The name of the cookie
 * @return {String}       The cookie value
 */
function getCookie (name) {
	let value = `; ${document.cookie}`;
	let parts = value.split(`; ${name}=`);
	if (parts.length === 2) return parts.pop().split(';').shift();
}